import Vue from 'vue'
import App from './App.vue'

import '@/assets/styles/reset.less'
import '@/assets/styles/font.less'

import store from './store'
import { isMobile } from '@/utils/env'
import { router } from '@/router'
import { Lazyload } from 'vant'

if (process.env.NODE_ENV !== 'production' && isMobile()) {
  import('eruda').then((eruda) => {
    eruda.default.init()
  })
}

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-weapp']

Vue.use(Lazyload, {
  lazyComponent: true,
})

new Vue({
  ...App,
  router,
  store,
}).$mount('#app')
